'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './text-link-buttons.component';
import dynamic from 'next/dynamic';

const DynamicTextLinkButtonsComponent: ComponentType<Props> = dynamic(
  () => import('./text-link-buttons.component')
);

export default DynamicTextLinkButtonsComponent;

export function calculateTextLinkButtonsPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 162 },
    { sinceWidth: 768, height: 192 }
  ];

  return {
    heightSinceWidth
  };
}
